import {useNavigate} from 'react-router-dom';
import {
  fetchRecommendationsRequest,
  updateRecommendationRequest,
} from 'APIs/letrusAPI/recommendations';
import getFeatureFlag from 'utils/functions/getFeatureFlags';
import useTrackEvent from 'utils/hooks/useTrackEvent';
import {getUserData} from 'utils/functions/getUserData/getUserData';
import {CTABanner} from 'containers/Dashboard/CTABanners/CTABannersCarousel';

function useRecommendationBanner({priority}: {priority: number}): CTABanner {
  const navigate = useNavigate();
  const {trackEvent} = useTrackEvent();

  const recommendationList = fetchRecommendationsRequest({}, 1);
  const updateRecommendation = updateRecommendationRequest();
  const {userRole} = getUserData();

  const latestRecommendation = recommendationList.data?.results
    .filter((recommendation) => recommendation.status === 'pending')
    .sort(compareRecommendationdates)[0];

  function compareRecommendationdates(first, second) {
    return (
      Math.abs(new Date(first?.created_at).getTime() - Date.now()) -
      Math.abs(new Date(second?.created_at).getTime() - Date.now())
    );
  }

  function handleRecommendationClick() {
    const recommendationId = latestRecommendation?.id;
    const questionnaireId = latestRecommendation?.instance.content_object?.pk;

    updateRecommendation.trigger({id: recommendationId, status: 'accepted'});
    navigate(`/atividades/pesquisa/${questionnaireId}`);

    trackEvent('clicked_on_recommendation_alert_student', {
      recommendation: {
        recommendation_instance_id: latestRecommendation?.instance.id ?? 0,
        recommendation_userinstance_id: latestRecommendation?.user ?? 0,
      },
      user: {
        userrole_id: userRole?.id,
      },
      network: {
        network_id: userRole?.school_network_id,
      },
      school: {
        school_id: userRole?.school,
        schoolgroup_id: userRole?.school_group,
      },
    });
  }

  return {
    priority,
    title: 'Atividade recomendada',
    theme: 'light',
    color: '#f78e16',
    icon: ['fad', 'book-open'],
    description:
      'Responda essas perguntas para melhorar ainda mais suas habilidades! \n Acesse e confira!',
    isVisible: () =>
      !!latestRecommendation &&
      getFeatureFlag('student_recommendations_and_alerts').isOn,
    action: {
      text: 'Acessar',
      onClick: () => handleRecommendationClick(),
    },
  };
}

export default useRecommendationBanner;
